import { createSlice } from '@reduxjs/toolkit'

import { addToCart_aggregated, submitForm_aggregated } from '../requests/thunks'

interface InternalSaveEventState {
  latestFulfilledId: string
}

const initialState: InternalSaveEventState = {
  latestFulfilledId: '', // uuidv4, when postConfig is fulfilled
}

const internalSaveEventSlice = createSlice({
  name: 'internalSaveEvent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addToCart_aggregated.fulfilled, (state, action) => {
        const { _internalSaveUuidv4 } = action.payload
        state.latestFulfilledId = _internalSaveUuidv4
      })
      .addCase(submitForm_aggregated.fulfilled, (state, action) => {
        const { _internalSaveUuidv4 } = action.payload
        state.latestFulfilledId = _internalSaveUuidv4
      })
  },
})

export default internalSaveEventSlice.reducer
